/* @flow */
// typecheck: ignore file
import React from 'react';
import Header from 'components/Header.jsx';
import HeaderLight from 'components/HeaderLight.jsx';
import cx from 'classnames';

import styles from './styles/MarketingLayout.css';

type Props = {
  location: Object,
  children?: ?any,
  light?: boolean,
  borderless?: boolean,
}

function MarketingLayout(props: Props) {
  const headerStyles = cx(styles.header, {
    [styles.headerBorder]: !props.borderless,
  });

  return (
    <div className={styles.this}>
      <div className={styles.headerContainer}>
        <div className={headerStyles}>
          {props.light
            ? <HeaderLight data-test="header-light" location={props.location} />
            : <Header data-test="header" location={props.location} />
          }
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.container}>
          {props.children}
        </div>
      </div>
    </div>
  );
}

export default MarketingLayout;



// WEBPACK FOOTER //
// ./src/components/MarketingLayout.jsx